import request, { ResponseData } from '@/libs/request/request'
import { Genealogy } from 'src/api/genealogy/Genealogy'
import { User } from 'src/api/user/User'

// GenealogyApply
export type GenealogyApply = {

  // 地址
  address?:string

  createBy?:number

  createByName?:string

  // 创建时间
  createTime?:string

  // 父亲名字
  fatherName?:string

  // 族谱名称
  genealogyName?:string

  // 业务Id
  id?:number

  // introduction
  introduction?:string

  // 是否同意申请
  isAgree?:number

  // 母亲名字
  motherName?:string

  // 轮播图场景名称
  name?:string

  // 手机号
  phone?:string

  updateBy?:number

  updateByName?:string

  // 更新时间
  updateTime?:string

  // 用户id
  userId?:number

  // 标题
  version?:number

  // 父亲电话
  fatherPhone?:string

  // 族谱id
  genealogyId?:number

  // 母亲电话
  motherPhone?:string

  // type
  type?:number

  genealogy?:Genealogy

  // 用户
  user?:User

  genealogySurname?:string

  // 出生时间}
  birth?:string

  // 城市
  city?:string

  // 性别 1:男 2:女
  gender?:number

  // 发布状态，1.发布成功 2.发布失败 3.禁止发布
  status?:number

  // 村庄名
  villageName?:string

  // 驳回原因
  because?:string
}

export default class GenealogyApplyService {
  /**
   * 同意一个族谱申请
   * @param {number} id 族谱申请实体id
   **/
  static updateOneGenealogyApply (id:number):Promise<ResponseData<GenealogyApply>> {
    return request<ResponseData<GenealogyApply>>({
      method: 'POST',
      url: `/admin/GenealogyApply/GenealogyApply/${id}`
    })
  }

  /**
   * 通过id获取一个族谱申请
   * @param {number} id 族谱申请id
   **/
  static getOneGenealogyApply (id:number):Promise<ResponseData<GenealogyApply>> {
    return request<ResponseData<GenealogyApply>>({
      method: 'GET',
      url: `/admin/GenealogyApply/GenealogyApply/${id}`
    })
  }

  /**
   * 删除一个族谱申请
   * @param {number} id 族谱申请id
   **/
  static deleteOneGenealogyApply (id:number):Promise<ResponseData<boolean>> {
    return request<ResponseData<boolean>>({
      method: 'DELETE',
      url: `/admin/GenealogyApply/GenealogyApply/${id}`
    })
  }

  /**
   * 同意一个退出族谱的申请
   * @param {number} id 申请id
   **/
  static withdrawGenealogyApply (id:number):Promise<ResponseData<GenealogyApply>> {
    return request<ResponseData<GenealogyApply>>({
      method: 'GET',
      url: `/admin/GenealogyApply/GenealogyApply/withdrawGenealogyApply/${id}`
    })
  }

  /**
   * 驳回一个族谱申请
   * @param {GenealogyApply} item 申请实体类
   **/
  static rejectApply (item?:GenealogyApply):Promise<ResponseData<string>> {
    return request<ResponseData<string>>({
      method: 'POST',
      data: item,
      url: '/admin/GenealogyApply/GenealogyApply/rejectApply'
    })
  }
}
